"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategories = void 0;
const routes_1 = require("../../routes");
const getCategories = (client) => async () => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_CATEGORIES.path);
    return response.data;
};
exports.getCategories = getCategories;
